import React, { createElement } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { Grid2 } from "@mui/material";
import { RouteList } from "helpers/route-config"
import Search from "components/portal/Search";
import { CleverString } from 'components/ui/CleverString';
import UnderConstruction from 'components/UnderConstruction';
import { loadDocumentTypes } from 'shared/services/documentTypeService';
import { loadFeatureToggles } from 'shared/services/featureToggleService';
import { initRelatedDocs } from 'components/ui/DocumentRules';
import { notificationsState } from './NotificationsState';
import { applicationState, getUserExistingRulebookMode, getUserRulebookModeFromLocation } from 'shared/store/applicationState';
import { RulebookEnumToString, RulebookModeEnum } from '../../shared/enums/rulebook-mode-enum';

interface BreadCrumbsProps {
    route: string;
    customBreadCrumbs?: any;
}

const BreadCrumbs = (props: BreadCrumbsProps) => {

    const items = props.route === "/" ? ["/"] : props.route.split("/");
    let endTrail = false;

    if (props.customBreadCrumbs != undefined) {
        return props.customBreadCrumbs();
    }

    return (
        <span className="breadcumb">
            {
                items.map((item, key, items) => {

                    if (endTrail === true) {
                        return;
                    }

                    let path = '';
                    for (let i = 0; i <= key; i++) {
                        if (!path.endsWith('/') && !items[i].startsWith('/')) {
                            path += '/';
                        }
                        path += items[i];
                    }

                    let matchedPath: string = "";

                    RouteList.forEach(route => {
                        let mp = matchPath(path, route?.path as string);
                        if (mp !== null && mp.pattern.end) {
                            matchedPath = mp.pathname;
                        }
                    });

                    const route = RouteList.find((r) => matchedPath === r.path);

                    if (route?.endTrail === true) {
                        endTrail = true;
                    }

                    let text = route?.breadCrumb ?? '';
                    if (typeof (text) !== 'string' || text.length < 1) {
                        text = item;
                    }
                    text = new CleverString(text).toTitleCase() as string;

                    var spacer = ` > `;

                    if (key == 0) {
                        spacer = '';
                    }

                    if ((endTrail || key + 1 === items.length) || !route || !route.breadCrumb || route.element === createElement(UnderConstruction))
                        return (
                            <React.Fragment key={key}>
                                {spacer}<span>{text}</span>
                            </React.Fragment>
                        );
                    else {
                        return (
                            <React.Fragment key={key}>
                                {spacer}<Link to={route.path as string}>{text}</Link>
                            </React.Fragment>
                        );
                    }
                })
            }
        </span>
    );
}

interface SubHeaderProps {
    color?: string;
    hideSearchBar?: boolean;
    customBreadCrumbs?: any;
}

export const SubHeader = (props: SubHeaderProps) => {
    const location = useLocation();
    const existingMode = getUserExistingRulebookMode();
    let currentMode = existingMode;
    currentMode = getUserRulebookModeFromLocation(location, currentMode);

    const initiailiseState = async () => {
        const profile = applicationState.getProfile();
        await loadDocumentTypes();
        await loadFeatureToggles();
        await initRelatedDocs(RulebookEnumToString(RulebookModeEnum.Traditional));
        if (profile?.cbtcTrained) {
            await initRelatedDocs(RulebookEnumToString(RulebookModeEnum.CBTC));
        } 
        notificationsState.setRequireRefresh(true);
        localStorage.removeItem('searchHistory');
    };

    if (currentMode != existingMode) {
        initiailiseState();
    }

    var style = {};

    if (props.color) {
        style = { backgroundColor: props.color, color: "white" };
    }

    return (
        <Grid2 container className="sub-header" style={style}>
            <Grid2 size={{ xs: 1, md: 8 }} className="header-breadcrumbs breadcumb-container center-children-vertically">
                <BreadCrumbs route={location.pathname} customBreadCrumbs={props.customBreadCrumbs} />
            </Grid2>
            <Grid2 size={{ xs:1, md:4}} className="site-search">
                {props.hideSearchBar !== true &&
                    <Search />
                }
            </Grid2>
        </Grid2>
    );
};

export default SubHeader;
